import constantData from '../../data/chuck-constants-data.json';

import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import memoize from 'lodash/memoize';

import { findChoice } from 'app/react-app/global/constants/utils';

export class ChuckConstantsInterface {
    constructor(data) {
        this.data = data;
        this.getAsChoices = memoize(this.getAsChoices);
    }

    get(path) {
        const value = get(this.data, path);
        if (isUndefined(value)) {
            throw new Error(`Constant ${path} not found`);
        }
        return value;
    }

    getAsChoices(path) {
        const constant = this.get(path);
        return constant.map(function(choice) {
            return { value: choice[0], label: choice[1] };
        });
    }

    getLabelForValue(path, value, defaultTo = '') {
        if (!value) {
            return defaultTo;
        }
        const choices = this.getAsChoices(path);
        return findChoice(choices, { value }, { pluck: 'label' });
    }

    getValueForLabel(path, label, defaultTo = '') {
        if (!label) {
            return defaultTo;
        }
        const choices = this.getAsChoices(path);
        return findChoice(choices, { label }, { pluck: 'value' });
    }
}

const chuckConstantsInterface = new ChuckConstantsInterface(constantData);

export default chuckConstantsInterface;
